export default {
  placeholders: {
    first_name: 'Imię',
    last_name: 'Nazwisko',
    email: 'E-mail',
    mobile_number: 'Numer telefonu',
  },
  labels: {
    exclusive_offers_via_email: 'Chcę otrzymywać ekskluzywne oferty i nowości e-mailem.',
  },
  buttons: {
    sign_up: 'Zarejestruj się',
  },
};
